export default __webpack_public_path__ + "static/media/coins.fcd632ad.svg";